"use client";

import React from "react";

interface MatIconProps {
  /** Material Symbols (Rounded) ligature name, e.g. "psychology" */
  name: string;
  size?: number;
  /** 0 = outlined, 1 = filled */
  fill?: boolean;
  weight?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Renders a Google Material Symbol (Rounded). The font is loaded globally in
 * tailwind.css. Use in place of emoji for consistent, professional iconography.
 */
const MatIcon: React.FC<MatIconProps> = ({
  name,
  size = 24,
  fill = false,
  weight = 400,
  className = "",
  style,
}) => {
  return (
    <span data-component-id="src/components/ui/MatIcon.tsx:29:4" data-component-path="src/components/ui/MatIcon.tsx" data-component-line="29" data-component-end-line="39" data-component-file="MatIcon.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`material-symbols-rounded ${className}`}
      aria-hidden="true"
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
        ...style,
      }}
    >
      {name}
    </span>
  );
};

export default MatIcon;
